import { Component } from '@angular/core';

import { MxAppSidebarService, MxMenuService } from '../../services';

@Component({
 standalone: false,
  selector: 'mx-main',
  templateUrl: './main.component.html',
})
export class MainComponent {
  menuMode = 'sidebar';

  overlayMenuActive!: boolean;

  staticMenuDesktopInactive = false;

  staticMenuMobileActive!: boolean;

  menuClick!: boolean;

  menuHoverActive = false;

  topbarMenuActive!: boolean;

  topbarItemClick!: boolean;

  activeTopbarItem: any;

  configActive!: boolean;

  configClick!: boolean;

  rightMenuActive!: boolean;

  rightMenuClick!: boolean;

  searchActive!: boolean;

  searchClick!: boolean;

  activeInlineProfile!: boolean;

  pinActive!: boolean;

  constructor(
    private menuService: MxMenuService,
    public appSidebarService: MxAppSidebarService
  ) {
    if (this.appSidebarService.sidebarStatic) {
      this.pinActive = true;
    }
  }

  onLayoutClick() {
    if (!this.topbarItemClick) {
      this.activeTopbarItem = null;
      this.topbarMenuActive = false;
    }

    if (this.configActive && !this.configClick) {
      this.configActive = false;
    }

    if (this.rightMenuActive && !this.rightMenuClick) {
      this.rightMenuActive = false;
    }

    if (this.searchActive && !this.searchClick) {
      this.searchActive = false;
    }

    if (!this.menuClick) {
      if ((this.isSlim() || this.isHorizontal()) && !this.isMobile()) {
        this.menuService.reset();
        this.menuHoverActive = false;
      }

      if (this.overlayMenuActive || this.staticMenuMobileActive) {
        this.overlayMenuActive = false;
        this.staticMenuMobileActive = false;
      }
    }

    this.configClick = false;
    this.rightMenuClick = false;
    this.searchClick = false;
    this.menuClick = false;
    this.topbarItemClick = false;
  }

  onSidebarClick(event: any) {
    this.menuClick = true;
  }

  onToggleMenu(event: any) {
    this.menuClick = true;

    if (this.overlayMenuActive) {
      this.overlayMenuActive = false;
    }

    if (this.appSidebarService.sidebarActive) {
      this.appSidebarService.sidebarStatic =
        !this.appSidebarService.sidebarStatic;
    }

    event.preventDefault();
  }

  onSidebarMouseOver(event: any) {
    if (this.menuMode === 'sidebar' && !this.appSidebarService.sidebarStatic) {
      this.appSidebarService.sidebarActive = this.isDesktop();
      setTimeout(() => {
        this.pinActive = this.isDesktop();
      }, 200);
    }
  }

  onSidebarMouseLeave(event: any) {
    if (this.menuMode === 'sidebar' && !this.appSidebarService.sidebarStatic) {
      setTimeout(() => {
        this.appSidebarService.sidebarActive = false;
        this.pinActive = false;
      }, 250);
    }
  }

  onMenuButtonClick(event: any) {
    this.menuClick = true;

    if (this.isOverlay()) {
      this.overlayMenuActive = !this.overlayMenuActive;
    }

    if (this.isDesktop()) {
      this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
    } else {
      this.staticMenuMobileActive = !this.staticMenuMobileActive;
    }

    event.preventDefault();
  }

  onTopbarItemClick(event: any, item: any) {
    this.topbarItemClick = true;

    if (this.activeTopbarItem === item) {
      this.activeTopbarItem = null;
    } else {
      this.activeTopbarItem = item;
    }

    event.preventDefault();
  }

  onTopbarSubItemClick(event: any) {
    event.preventDefault();
  }

  onConfigClick(event: any) {
    this.configClick = true;
  }

  onRightMenuButtonClick() {
    this.rightMenuClick = true;
    this.rightMenuActive = true;
  }

  onRightMenuClick(event: any) {
    this.rightMenuClick = true;
  }

  isStatic() {
    return this.menuMode === 'static';
  }

  isOverlay() {
    return this.menuMode === 'overlay';
  }

  isSlim() {
    return this.menuMode === 'slim';
  }

  isHorizontal() {
    return this.menuMode === 'horizontal';
  }

  isSidebar() {
    return this.menuMode === 'sidebar';
  }

  isDesktop() {
    return window.innerWidth > 991;
  }

  isMobile() {
    return window.innerWidth <= 991;
  }
}

